<script>
  import { createEventDispatcher } from 'svelte';

  import { Button } from 'carbon-components-svelte';

  import SaveFeedsConfirmationModal from './SaveFeedsConfirmationModal.svelte';

  export let feedDifference,
    feedIdsRequiringApprovalSet,
    submitDisabled,
    onSubmitChanges,
    supportsObjectRestore,
    selectedRowIds,
    validationErrors,
    draftEntitlements;

  const dispatch = createEventDispatcher();

  let confirmationModal = false;

  $: validationErrorExists = Object.values(validationErrors).some((rowValidationErrors) =>
    Object.values(rowValidationErrors)?.some(Boolean)
  );

  $: totalChanges =
    Object.keys(feedDifference.created ?? {}).length +
    Object.keys(feedDifference.updated ?? {}).length +
    Object.keys(feedDifference.deleted ?? {}).length;
</script>

{#if draftEntitlements.length || totalChanges}
  <div class="button-wrapper">
    {#if supportsObjectRestore}
      <Button size="field" disabled={!selectedRowIds.length} kind="tertiary" on:click={() => dispatch('object-restore')}>
        <span>Request Restore</span>
        {#if selectedRowIds.length}
          <i>({selectedRowIds.length})</i>
        {/if}
      </Button>
    {/if}
    <Button
      size="field"
      disabled={submitDisabled || validationErrorExists || !totalChanges}
      on:click={() => {
        confirmationModal = true;
      }}
    >
      Save Changes
      {#if totalChanges}
        <i>({totalChanges})</i>
      {/if}
    </Button>
  </div>
{/if}

<SaveFeedsConfirmationModal
  bind:open={confirmationModal}
  {feedDifference}
  {feedIdsRequiringApprovalSet}
  {supportsObjectRestore}
  {selectedRowIds}
  {onSubmitChanges}
  on:object-restore
/>

<style>
  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
    position: sticky;
    bottom: -1rem;
    z-index: 2;
    background: var(--cds-ui-01);
    padding: 1rem 0;
    gap: 0.5rem;
    flex-direction: column;
  }

  .button-wrapper :global(.bx--btn i) {
    margin-left: 0.25rem;
    font-size: 0.75rem;
  }

  .button-wrapper :global(.bx--btn) {
    max-width: unset;
  }

  @media (min-width: 42rem) {
    .button-wrapper {
      bottom: -2rem;
      flex-direction: row;
    }
  }
</style>
